<template>
    <div>
        <top-bar>
            <div class="title">
                薪资月份：
                <span @click="showPopup" class="month">
                    {{ currentFormat }}
                    <van-icon name="arrow-down" />
                </span>
                <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
                    <van-datetime-picker
                        type="year-month"
                        title="选择年月"
                        :min-date="minOrMaxDate.minDate"
                        :max-date="minOrMaxDate.maxDate"
                        :formatter="formatter"
                        v-model="current"
                        @confirm="confirm"
                        @cancel="cancel"
                        @change="getSalary"
                    />
                </van-popup>
            </div>
        </top-bar>
        <ul class="userinfo" v-if="salaryList.length">
            <li v-for="item in salaryList" :key="item.id">
                <div>{{ item.text }}：</div>
                <span>{{ item.value }}</span>
            </li>
        </ul>
        <err msg="本月微薪暂未导入," v-else />
        <van-dialog v-model="showY" title="提示" @confirm="confirmenter">
            <div class="cont">点击进行实名验证</div>
        </van-dialog>
    </div>
</template>

<script>
import TopBar from "@/components/Top";
import err from "./err";
import { getHttpAction,getOpenId } from "@/http/salary";
import { init,GetQueryString } from '@/utils/getOpenId'
import { formatter } from '@/common/common'

export default {
    components: {
        TopBar,
        err,
    },
    data() {
        return {
            show: false,
            date: new Date(),
            salaryList: [],
            current: new Date(),
            showY:false,
            hasVal:''
        };
    },
    computed: {
        day() {
            let year = this.date.getFullYear();
            let month = this.date.getMonth() + 1;
            let day = this.date.getDate();
            day = day > 10 ? day : "0" + day;
            month = month > 10 ? month : "0" + month;
            return `${year}-${month}-${day}`;
        },
        month() {
            let year = this.date.getFullYear();
            let month = this.date.getMonth() + 1;
            month = month > 9 ? month : "0" + month;
            return `${year}-${month}`;
        },
        minOrMaxDate() {
            let date = new Date();
            let currentYear = date.getFullYear();
            return {
                minDate: new Date(currentYear - 2, 0, 1),
                maxDate: new Date(currentYear, 10, 1),
            };
        },
        currentFormat(){
            return formatter(this.current,'yyyy-MM')
        },
        async currentDate(){
            let t = await this.getSalaryMonth()
            let time = `${t.slice(5,7)}/01/${t.slice(0,4)}`
            let date = new Date(time)
            this.current = date
            return date
        }
    },
    created() {
        this.$cookies.set('history','Salary',60 * 60 * 1)
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }
        this.getSalaryMonth()

        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','Salary',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/Salary')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=Salary#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        //     this.getSalary();
        // }
    },
    watch:{
        hasVal(val,oval){
            let t = this.hasVal
            let time = `${t.slice(5,7)}/01/${t.slice(0,4)}`
            this.current = new Date(time)
            this.getSalary();
        }
    },
    methods: {
         async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        async getSalary(payday = this.day) {
            let time = formatter(this.current,'yyyy-MM')+''
            const res = await getHttpAction("/front/salary/info",{date:time});
            if(res.msg == 'success'){
                this.salaryList = res.mapList
            }else if(res.msg == '您还没有实名认证'){
                this.showY = true
            }else{
                this.salaryList = []
            }
        },
        showPopup() {
            this.show = true;
        },
        formatter(type, val) {
            if (type === "year") {
                return `${val}年`;
            } else if (type === "month") {
                return `${val}月`;
            }
            return val;
        },
        confirm(e) {
            this.show = false;
            let year = e.getFullYear();
            let month = e.getMonth() + 1;
            this.date = e;
        },
        cancel() {
            this.show = false;
        },
        confirmenter(){
            this.$cookies.set('history','Salary',60 * 60 * 1)
            this.$router.push('./Certification')
        },
        async getSalaryMonth(){
            return getHttpAction('/front/salary/getNewYearMonth').then((res) => {
                if(res.msg == 'success'){
                    this.hasVal = res.data
                    return res.data
                }else if(res.msg == '您还没有实名认证'){
                    this.showY = true
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    font-weight: 700;
    align-items: center;
    .month {
        font-weight: 400;
        width: 70%;
    }
}
.userinfo {
    width: 100%;
    align-items: center;
    height: 100vh;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    li {
        list-style: none;
        margin: 10px;
        padding: 10px;
        border-bottom: 1px dashed #E0DBDB;

        div {
            font-weight: 600;
            font-size: 14px;
            display: inline-block;
            min-width: 100px;
            text-align-last: right;
        }
    }
}
.cont{
    text-align: center;
    padding: 20px;
}
</style>
